import React, { useState, useContext, useEffect } from "react";
import { CgChevronRightO } from "react-icons/cg";
import { CgChevronLeftO } from "react-icons/cg";
import Number from "./Number";
import Ticket from "./Ticket";
import { PickNumberContext } from "../../pages/PickTicket";
import { getRandomInt } from "../../utils";
import { numbers } from "../../constant/lottery";
import { v4 as uuid } from "uuid";

export default function NumberPanel() {
  const id = uuid().slice(0, 8);
  const { pickedNum, setPickedNum, ticketCount } = useContext(PickNumberContext);

  const [count, setCount] = useState(0);
  const [pickedNumber, setPickedNumber] = useState([]);
  const [ticketNumber, setTicketNumber] = useState(0);

  const handlePickNum = (num, pickedNumber) => {
    for (let i = 0; i < pickedNumber?.length; i++) {
      if (num == pickedNumber[i]) return true;
    }
    return false;
  };

  const handleNumber = (num) => {
    let list = pickedNumber;
    const index = pickedNumber.indexOf(num);
    if (index > -1) {
      list.splice(index, 1);
      setCount(list.length);
      setPickedNumber(list);
    } else {
      setCount(pickedNumber.length + 1);
      setPickedNumber([...pickedNumber, num]);
    }
  };

  const onPrevTicket = () => {
    if (ticketNumber <= 0) setTicketNumber(0);
    else setTicketNumber(ticketNumber - 1);
  };
  const onNextTicket = () => {
    if (ticketNumber >= ticketCount - 1) setTicketNumber(ticketCount - 1);
    else setTicketNumber(ticketNumber + 1);
  };
  const onSkipAllTicket = () => {
    let random = [];
    let count = 0;
    while (count < 6) {
      const randomInt = getRandomInt(1, 65);
      const index = random.indexOf(randomInt);
      if (index > -1) continue;
      else random.push(randomInt);
      count++;
    }
    setCount(6);
    setPickedNumber(random);
  };
  const onClearAllTicket = () => {
    setCount(0);
    setPickedNumber([]);
  };

  const onSaveTicket = () => {
    if (ticketCount <= pickedNum.length) return;
    const pick = { id: id, pick: [...pickedNumber] };
    let newArr = [...pickedNum, pick];
    setPickedNum([...newArr]);
    onNextTicket();
    setCount(0);
    setPickedNumber([]);
  };

  return (
    <>
      <div className="number-panel">
        <div className="grid grid-cols-10 gap-2">
          {numbers?.map((num, i) => (
            <Number
              key={i}
              num={num}
              count={count}
              picked={handlePickNum(num, pickedNumber)}
              final={count > 5 && num === pickedNumber[5]}
              handleNumber={(pnum) => handleNumber(pnum)}
            />
          ))}
        </div>
      </div>

      <Ticket pickedNumber={pickedNumber} />

      <div className="control">
        <button className="rounded-xl px-1 border border-[#8af0b7]" onClick={onSkipAllTicket}>
          Random all
        </button>
        <div className="flex justify-center items-center rounded-xl px-1 border border-[#8af0b7]">
          <button onClick={onPrevTicket}>
            <CgChevronLeftO style={{ fontSize: "16px", color: "fff", marginRight: "20px" }} />
          </button>
          Ticket #{ticketNumber + 1}
          <button onClick={onNextTicket}>
            <CgChevronRightO style={{ fontSize: "16px", color: "fff", marginLeft: "20px" }} />
          </button>
        </div>
        <button className="rounded-xl px-1 border border-[#8af0b7]" onClick={onClearAllTicket}>
          Clear all
        </button>
      </div>
      <button className="save-ticket" onClick={onSaveTicket} disabled={count < 6}>
        Save Ticket
      </button>
    </>
  );
}
